import { render, staticRenderFns } from "./dex-pn.vue?vue&type=template&id=fbaf42be&scoped=true"
import script from "./dex-pn.vue?vue&type=script&lang=ts"
export * from "./dex-pn.vue?vue&type=script&lang=ts"
import style0 from "./dex-pn.vue?vue&type=style&index=0&id=fbaf42be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaf42be",
  null
  
)

export default component.exports